import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { MENU } from '@/constants/menu';
import MenuLink from '../MenuLink';
import styles from './NavBarDropdown.module.scss';

const NavBarDropdown = ({ isOpen, navBarMenu, activeMenu, onSelectMenu, onClickMenu }) => {
	const isActiveLink = useCallback((item) => isOpen && activeMenu === item._id, [isOpen, activeMenu]);

	return (
		<div className={styles['navbar-nav-container']} data-test-id="navbar-dropdown-container">
			<div className="navbar-nav" data-test-id="navbar-dropdown" role="menu">
				{navBarMenu.map((item) => (
					<span className="nav-item" key={item._id} aria-expanded={isActiveLink(item)} role="menuitem">
						<MenuLink
							isMobile={false}
							type={MENU.NAVBAR}
							link={item}
							handleMouseEnter={() => onSelectMenu(item._id)}
							isOpen={isOpen}
							isActiveLink={isActiveLink(item)}
							handleClick={() => onClickMenu(item.name)}
						/>
					</span>
				))}
			</div>
		</div>
	);
};

NavBarDropdown.propTypes = {
	isOpen: PropTypes.bool,
	navBarMenu: PropTypes.array.isRequired,
	activeMenu: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onSelectMenu: PropTypes.func.isRequired,
	onClickMenu: PropTypes.func.isRequired,
};

export default React.memo(NavBarDropdown);
